module.exports = __webpack_public_path__ + "img/backtracking.bf780fbe.svg";